import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-participant-study-not-found',
  templateUrl: './participant-study-not-found.component.html',
  styleUrls: ['./participant-study-not-found.component.css'],
  standalone: true
})
export class ParticipantStudyNotFoundComponent  {

  constructor(private router: Router) { }
 
  callParticipantHome(): void {
    this.router.navigateByUrl('');
  }

}
